import {Component, Input} from "@angular/core";
import {ICollapseEvents} from "./ICollapseEvents";
const $ = require('jquery');

@Component({
    selector: 'collapse-form-child',
    template: require('./collapse.form.child.template.html')
})
export class CollapseFormChildComponent {

    @Input() id: number;
    @Input() openByDefault: boolean;

    public toggle(): void {
        $(`#collapse${this.id}`).collapse('toggle');
    }

    public show(): void {
        $(`#collapse${this.id}`).collapse('show');
    }

    public hide(): void {
        $(`#collapse${this.id}`).collapse('hide');
    }

    public initEvents(events: ICollapseEvents): void {
        $(`#collapse${this.id}`).on('show.bs.collapse', (event)=> {
            events.onShow.emit(event);
        }).on('shown.bs.collapse', (event)=> {
            events.onShown.emit(event);
        }).on('hidden.bs.collapse', (event)=> {
            events.onHidden.emit(event);
        }).on('hide.bs.collapse', (event)=> {
            events.onHide.emit(event);
        });
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/collapse/child/collapse.form.child.component.ts